import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const legReceiverFields: FieldInterface[] = [
  {
    key: 'part',
    originKey: 'part',
    type: FIELD_TYPES.number,
  },
  {
    key: 'personId',
    originKey: 'person_id',
    type: FIELD_TYPES.string,
  },
  {
    key: 'amount',
    originKey: 'amount',
    type: FIELD_TYPES.number,
  },
]

const legReceiverRelations: RelationInterface[] = [
  {
    key: '_legacy',
    originKey: 'legacy',
    objectType: OBJECT_TYPES.leg,
  },
  {
    key: '_receiver',
    originKey: 'receiver',
    objectType: OBJECT_TYPES.legReceiver,
  },
]

export { legReceiverFields, legReceiverRelations }
